export class procedureModal{
    ProcedureDate?:any
    FK_DoneById?:number
    DoneBy?:any
    FK_RegisterSourceDetailId?:number
    fK_RegisterSourceDetailId?:any
    FK_AdvisedById?:number
    Eye?:any
    ImgUploaded?:boolean
    IsActive?:boolean
    ConsentTaken?:boolean
    ConsentUploaded?:boolean
    procName?:any
    source?:any
    advisedByUserName?:any
    procedureId?:any
    pK_TransactionId?:any
    comments?:any
    performTime?:any
  }
  export class DocFileModel {
    public pk_TranId?: number;
    public fk_BranchId?: number;
    public fk_RegId?: number;
    public documentType?: string;
    public documentName?: string;
    public documentURL?: string;
    public fk_CreatedById?: number;
    public createdDateTime?: any;
    public fk_DeletedById?: any;
    public deletedDateTime?: any;
    public createdBy?: string;
    public deletedBy?: string;
    public folderNameMain?: string;
    public branchId?: number;
    public patientId?: number;
    public userId?: number;
    public actionType?: string;
    public storageType?: string;
    public thubnail?:any;
    public fbLong?:any;
    public selectfile?:boolean;
}